import { RequestEnvelope } from "@cur8/api-client/dist/api/types";

export function applySignal<T>(req: RequestEnvelope<T>, signal: AbortSignal) {
  signal.addEventListener("abort", () => req.abandon());
}
